/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Not_FollowedInputs */



/**
* | output |
* | --- |
* | "Wundo does not help with this conversation." |
*
* @param {Meeting_Prep_Not_FollowedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_not_followed = /** @type {((inputs?: Meeting_Prep_Not_FollowedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Not_FollowedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo helpt niet bij dit gesprek.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'aide pas pour cette conversation.")
	return /** @type {LocalizedString} */ ("Wundo does not help with this conversation.")
});